export const Colors = {
    bioretisBlue : 'rgb(101,122,151)',
    bioretisBlueLight : 'rgba(101,122,151,0.2)',
    bioretisDark : '#061A28FF',
    white : '#fff',
    bioretisContrast : 'rgb(236,175,110)',
}